
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-summarizer",
      function () {
        return require("private-next-pages/ai-summarizer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-summarizer"])
      });
    }
  